import api from '../index'

/**
 * 用户管理模块接口
 */

// 用户列表查询参数类型
interface UserListParams {
  page?: number
  limit?: number
  search?: {
    username?: string
    phone?: string
    email?: string
    status?: number
  }
}

// 创建用户参数类型
interface CreateUserData {
  username: string
  phone: string
  email?: string
  password: string
  system?: number
  status?: number
  remark?: string
}

// 更新用户参数类型
interface UpdateUserData {
  username?: string
  phone?: string
  email?: string
  password?: string
  system?: number
  status?: number
  remark?: string
}

// 用户角色配置参数类型
interface UserRoleData {
  user_id: number
  role_ids: number[]
}

// 用户部门配置参数类型
interface UserDepartmentData {
  user_id: number
  department_ids: string[]
}

export default {
  // 获取用户列表
  getUserList: (params?: UserListParams) => {
    return api.get('/user/getUserList', { params })
  },

  // 获取用户详情
  getUserDetail: (id: number) => {
    return api.get(`/user/getUserDetail`, { params: { id } })
  },

  // 创建用户
  createUser: (data: CreateUserData) => {
    return api.post('/user/createUser', data)
  },

  // 更新用户
  updateUser: (id: number, data: UpdateUserData) => {
    return api.post('/user/updateUser', { id, ...data })
  },

  // 删除用户
  deleteUser: (id: number) => {
    return api.post('/user/deleteUser', { id })
  },

  // 重置用户密码
  resetUserPassword: (id: string) => {
    return api.post('/user/resetUserPassword', { id })
  },

  // 获取用户角色列表
  getUserRoles: (userId: number) => {
    return api.get(`/user/getUserRoles`, { params: { id: userId } })
  },

  // 获取用户部门列表
  getUserDepartments: (userId: number) => {
    return api.get(`/user/getUserDepartments`, { params: { id: userId } })
  },

  // 分配用户角色
  assignUserRoles: (data: UserRoleData) => {
    return api.post('/user/assignUserRoles', data)
  },

  // 分配用户部门
  assignUserDepartments: (data: UserDepartmentData) => {
    return api.post('/user/assignUserDepartments', data)
  },
}
